import React from 'react';
interface OrderBumpProps {
  isBumpSelected: boolean;
  setIsBumpSelected: (val: boolean) => void;
}
export function OrderBump({
  isBumpSelected,
  setIsBumpSelected
}: OrderBumpProps) {
  return <div className="max-w-3xl mx-auto mt-4 mb-4 px-4" data-id="element-191">
      {/* Outer wrapper: Soft Cream bg + Gold Dashed Border + Outer Glow */}
      <div className="rounded-[20px] p-1" style={{
      backgroundColor: '#FFFDFA',
      border: '2px dashed #D4AF37',
      boxShadow: '0 4px 24px rgba(212, 175, 55, 0.25), 0 2px 8px rgba(0,0,0,0.08)'
    }} data-id="element-192">
        <div className={`relative rounded-[18px] p-6 pt-10 transition-all duration-300 cursor-pointer ${isBumpSelected ? 'ring-2 ring-brand-teal ring-offset-2' : ''}`} style={{
        backgroundColor: '#FFFDFA'
      }} onClick={() => setIsBumpSelected(!isBumpSelected)} data-id="element-193">
          {/* Floating Red Urgency Banner — centered on mobile */}
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10 w-[90%] sm:w-auto flex justify-center" data-id="element-194">
            <div className="px-4 py-2 rounded-full text-white font-bold text-xs sm:text-sm tracking-wide shadow-lg text-center" style={{
            backgroundColor: '#DC2626'
          }} data-id="element-195">
              OFERTA FLASH: SOLO $4.90 (VALOR REAL $14)
            </div>
          </div>

          {/* Pack title */}
          <p className="text-center font-bold text-brand-teal text-sm sm:text-base mb-4 mt-2" data-id="element-196">
            🎁 COMPLETA TU PACK (PASO OPCIONAL):
          </p>

          <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-197">
            {/* Image on the left */}
            <div className="flex-shrink-0 w-full md:w-32" data-id="element-198">
              <img src="https://cdn.magicpatterns.com/uploads/api8pp2fYzuYrxpaGXSkFH/nuevobump.png" alt="El Código del Silencio" className="w-full h-auto rounded-[12px] shadow-md" data-id="element-199" />
            </div>

            <div className="flex-grow" data-id="element-200">
              <p className="mb-2 text-base sm:text-lg" style={{
              color: '#0F3C3C',
              fontWeight: 600
            }} data-id="element-201">
                Evite destrozos y quejas de vecinos cuando usted sale de casa.
              </p>

              {/* Checkbox-style toggle */}
              <div className="flex items-start gap-3 mt-4" data-id="element-202">
                <div className={`relative w-14 h-8 rounded-full transition-colors duration-300 flex-shrink-0 mt-0.5 ${isBumpSelected ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-203">
                  <div className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ${isBumpSelected ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-204"></div>
                </div>
                <span className="text-sm font-semibold text-gray-700 leading-snug" data-id="element-205">
                  {isBumpSelected ? '✅ Añadido al pack' : 'SÍ, AÑADIR EL CÓDIGO DEL SILENCIO POR SOLO $4.90 (Ahorre $9.10 adicionales hoy).'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}